module.exports = __webpack_public_path__ + "static/img/footer.eb217a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/footer.png
// module id = E9O7
// module chunks = 0